<script lang="ts">
  import { onMount } from 'svelte';
  import { Col, Row } from "sveltestrap"

  export let src: string;
  export let table: boolean = false;

  let img: object;
  let cls = '';

  let onLoad = () => {
    if (img.offsetWidth > img.offsetHeight) {
      cls = 'img-horizontal'
    }
    else if (img.offsetWidth < img.offsetHeight) {
      cls = 'img-vertical'
    }
    else {
      cls = 'img-square'
    }
    if (table) {
      cls += ' img-table'
    }
  };
</script>

{#if cls.startsWith('img-vertical')}
  <Row class="img-background align-content-center g-0">
    <Col class="img-container text-center">
      <img class={cls} src={src} bind:this={img} alt="placeholder" on:load={onLoad} onerror="this.src='/placeholder.svg'"/>
    </Col>
  </Row>
{:else}
  <Row class="img-background img-container align-content-center g-0">
    <Col class="text-center">
      <img class={cls} src={src} bind:this={img} alt="placeholder" on:load={onLoad} onerror="this.src='/placeholder.svg'"/>
    </Col>
  </Row>
{/if}
